<div>
    <div style="margin-left: 80%; margin-bottom: 2%;">

        <button type="button" mat-raised-button matTooltip="Download Execelsheet" class="btn btn-danger"
            (click)="exportexcel('Address')" style="margin-top: 2%;">
            Export
        </button>

        <button (click)="print()" class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button
            color="primary">
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>

    <div class="container">
        <table class="table" id="print-section">
            <colgroup>
                <col style="width: 4%;">
                <col style="width: 13%;">
                <col style="width: 35%;">
                <col style="width: 9%;">
                <col style="width: 9%;">
                <col style="width: 8%;">
                <col style="width: 9%;">
                <col style="width: 13%;">
            </colgroup>
            <thead>
                <tr>
                    <th>अ.क्र.</th>
                    <th>नाव</th>
                    <th>पत्ता</th>
                    <th>तालुका</th>
                    <th>जिल्हा</th>
                    <th>पिनकोड</th>
                    <th>राज्य</th>
                    <th>मो.क्र.</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data2 of flatAddresses; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td style="font-weight: bold;">{{ data2.name }}</td>
                    <td>{{ data2.address }}</td>
                    <td>{{ data2.taluka }}</td>
                    <td>{{ data2.district }}</td>
                    <td>{{ data2.pincode }}</td>
                    <td>{{ data2.state }}</td>
                    <td style="font-weight: bold;text-align: end;">{{ data2.mobile }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>